import BalanceDetail from './BalanceDetail';
import BalancePage from './BalancePage';
import BankKYC from './BankKYC';
import Collection from './CollectionDetails';
import CollectionPage from './CollectionPage';
import EditProfile from './EditProfile';
import EmailVerification from './EmailVerification';
import FAQ from './FAQ';
import ForgetPassword from './ForgetPassword';
import Home06 from './Home06';
import IdentityKYC from './IdentityKYC';
import LaunchpadDetail from './LaunchpadDetail';
import LaunchpadPage from './LaunchpadPage';
import Login from './Login';
import NFTDetails from './NFTDetails';
import NoResult from './NoResult';
import Profile from './Profile';
import ReceiptDetail from './ReceiptDetail';
import ReceiptPage from './ReceiptPage';
import Register from './Register';
import ResetPassword from './ResetPassword';
import SearchResult from './SearchResult';

const routes = [
  { path: '/', component: <Home06 /> },
  { path: '/collection', component: <CollectionPage /> },
  { path: '/collection/:_paramsChainId', component: <CollectionPage /> },
  {
    path: '/collection/:_paramsChainId/:collectionIdentifier',
    component: <Collection />,
  },
  { path: '/launchpad', component: <LaunchpadPage /> },
  { path: '/launchpad/:_paramsChainId', component: <LaunchpadPage /> },
  {
    path: '/launchpad/:_paramsChainId/:launchpadIdentifier/',
    component: <LaunchpadDetail />,
  },
  { path: '/profile/:uuid', component: <Profile /> },
  { path: '/edit-profile', component: <EditProfile /> },
  { path: '/edit-profile/id-KYC', component: <IdentityKYC /> },
  { path: '/edit-profile/bank-KYC', component: <BankKYC /> },
  { path: '/receipt', component: <ReceiptPage /> },
  { path: '/receipt/:invoiceId', component: <ReceiptDetail /> },
  { path: '/balance', component: <BalancePage /> },
  { path: '/balance/:invoiceId', component: <BalanceDetail /> },
  {
    path: '/nft/:_paramsChainId/:collectionIdentifier/:_tokenId',
    component: <NFTDetails />,
  },
  { path: '/search/:category', component: <SearchResult /> },
  { path: '/faq', component: <FAQ /> },
  { path: '/login', component: <Login /> },
  { path: '/register', component: <Register /> },
  { path: '/forget-password', component: <ForgetPassword /> },
  { path: '/reset-password', component: <ResetPassword /> },
  { path: '/email-verification', component: <EmailVerification /> },
  { path: '/no-result', component: <NoResult /> },
  { path: '*', component: <NoResult /> },
];

export default routes;
